import styled from 'styled-components';

import theme from '../../../../../theme';

const OAUTH_PAUSED_FOOTER_HINT_BACKGROUND = `${theme.colors.infoRed1}1A`;

export const FOOTER_CUSTOM_STYLE = {
  'background-color': 'transparent',
  'box-shadow': 'none',
  bottom: 'auto',
  flexShrink: 0,
  height: 'calc(100% - calc(100% - (64px + 24px)))',
  padding: '24px 0px',
  position: 'relative',
  width: '100%',
};

export const FOOTER_BUTTON_STYLE = {
  boxSizing: 'border-box',
  flex: 1,
  justifyContent: 'center',
  minWidth: 0,
  padding: '0px 40px',
};

export const FOOTER_DEACTIVATE_BUTTON_STYLE = {
  ...FOOTER_BUTTON_STYLE,
  backgroundColor: 'transparent',
  border: `2px solid ${theme.colors.infoRed}`,
  color: theme.colors.infoRed,
};

export const FOOTER_DEACTIVATE_ICON_STYLE = {
  filter: 'none',
};

export const PanelRoot = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  padding: 0 24px;
`;

export const HeaderRow = styled.div`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  justify-content: space-between;
  padding: 20px 0 16px;
`;

export const LogoAndTitle = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  gap: 12px;
  min-width: 0;
`;

export const PartnerNameRow = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-start;
  min-width: 0;
`;

export const PartnerTitleAndStatus = styled.div`
  align-items: center;
  display: inline-flex;
  gap: 16px;
  max-width: 100%;
  min-width: 0;
`;

export const IconWrapper = styled.div`
  align-items: center;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  border-radius: 50%;
  display: flex;
  flex-shrink: 0;
  height: 32px;
  justify-content: center;
  text-transform: uppercase;
  width: 32px;
`;

export const LogoImage = styled.img`
  border-radius: 8px;
  flex-shrink: 0;
  height: 32px;
  object-fit: contain;
  width: 32px;
`;

export const PartnerNameHost = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;

  & > div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
  }
`;

export const CloseButton = styled.button`
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
  height: 32px;
  justify-content: center;
  padding: 4px;
  width: 32px;

  &:hover {
    opacity: 0.7;
  }
`;

export const Divider = styled.div`
  background-color: ${({ theme }) => theme.colors.greys.light};
  flex-shrink: 0;
  height: 1px;
  width: 100%;
`;

export const BodyScroll = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 24px 0;
`;

/** Separates integration description / token field from the external-entity mapping UI. */
export const MappingSectionHost = styled.div`
  margin-top: 16px;
`;

export const BodyTitleHost = styled.div`
  margin-bottom: 16px;
`;

export const PanelBodyDescriptionHost = styled.div`
  white-space: pre-line;
`;

export const PanelBodyBulletList = styled.ul`
  color: ${({ theme }) => theme.colors.blacks.ipBlack1};
  font: ${({ theme }) => theme.fonts.textInterRegular12Height20};
  list-style-type: disc;
  margin: 0;
  padding-left: 20px;

  & > li {
    margin-bottom: 8px;
  }

  & > li:last-child {
    margin-bottom: 0;
  }
`;

export const TokenFieldLabelHost = styled.div`
  margin-top: 16px;
`;

export const TokenInputField = styled.input`
  border: 1px solid ${({ theme }) => theme.colors.greys.light};
  border-radius: ${({ theme }) => theme.borders.radius.weak};
  box-sizing: border-box;
  font: ${({ theme }) => theme.fonts.textInterRegular14Height20};
  margin-top: 8px;
  padding: 10px 12px;
  width: 100%;
`;

export const FeedbackMessageHost = styled.div`
  margin-top: 16px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
`;

export const OauthFooterHintHost = styled.div`
  flex-shrink: 0;
  margin-top: ${({ $hintPlacement }) => {
    if ($hintPlacement === 'belowHeader') {
      return '24px';
    }

    if ($hintPlacement === 'belowMapping') {
      return '24px';
    }

    return '0';
  }};
  padding-bottom: ${({ $hintPlacement }) => {
    if ($hintPlacement === 'aboveFooter') {
      return '16px';
    }

    return $hintPlacement === 'belowHeader' ? '16px' : '24px';
  }};
  padding-top: ${({ $hintPlacement }) => ($hintPlacement === 'aboveFooter' ? '16px' : '0')};
  width: 100%;
`;

export const OauthFooterHintBox = styled.div`
  background-color: ${({ $footerHintTone, theme }) =>
    $footerHintTone === 'warning'
      ? OAUTH_PAUSED_FOOTER_HINT_BACKGROUND
      : theme.colors.blacks.ipBlack7};
  border-radius: ${({ theme }) => theme.borders.radius.weak};
  padding: 12px 14px;
`;

export const OauthFooterHintText = styled.div`
  color: ${({ theme }) => theme.colors.greys.darker};
  font: ${({ theme }) => theme.fonts.textSmallHeight16};
`;
